import { useState, useEffect } from 'react';

export default function MobileRedirectNotice() {
  const [isMobile, setIsMobile] = useState(false);
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    // Function to detect mobile devices
    const checkMobile = () => {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      
      // Regular expressions to check for mobile devices
      const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
      
      // Update state based on detection
      setIsMobile(mobileRegex.test(userAgent));
    };
    
    // Function to update current path
    const updatePath = () => {
      setCurrentPath(window.location.pathname);
    };
    
    // Check when component mounts
    checkMobile();
    updatePath();
    
    // Also check when window resizes
    window.addEventListener('resize', checkMobile);
    
    // Listen for route changes
    window.addEventListener('popstate', updatePath);
    
    // Clean up event listeners
    return () => {
      window.removeEventListener('resize', checkMobile);
      window.removeEventListener('popstate', updatePath);
    };
  }, []);

  // Check if current path is the quotations route
  const isQuotationsRoute = currentPath.startsWith('/quotations/');

  // If not mobile or on quotations route, render nothing
  if (!isMobile || isQuotationsRoute) {
    return null;
  }

  // Render mobile notification for SiteMaster
  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-90 flex items-center justify-center z-50 p-6">
      <div className="bg-white rounded-xl shadow-2xl p-6 max-w-md animate-fade-in">
        <div className="flex justify-center mb-6">
          <div className="bg-purple-700 text-white p-4 rounded-full">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect>
              <rect x="9" y="9" width="6" height="6"></rect>
              <line x1="9" y1="2" x2="9" y2="4"></line>
              <line x1="15" y1="2" x2="15" y2="4"></line>
              <line x1="9" y1="20" x2="9" y2="22"></line>
              <line x1="15" y1="20" x2="15" y2="22"></line>
              <line x1="20" y1="9" x2="22" y2="9"></line>
              <line x1="20" y1="15" x2="22" y2="15"></line>
              <line x1="2" y1="9" x2="4" y2="9"></line>
              <line x1="2" y1="15" x2="4" y2="15"></line>
            </svg>
          </div>
        </div>
        
        <h2 className="text-2xl font-bold text-center mb-2">Desktop Access Required</h2>
        
        <p className="text-gray-600 mb-6 text-center">
          SiteMaster provides an advanced web editing experience that requires a desktop browser. 
          Please access this application from your desktop or laptop computer.
        </p>
        
        <div className="flex justify-center mb-6">
          <div className="flex items-center justify-center space-x-2 text-gray-500">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
            <span>Desktop Recommended</span>
          </div>
        </div>
        
        <div className="flex flex-col space-y-3">
          <button 
            className="bg-purple-700 hover:bg-blue-700 text-white py-3 px-4 rounded-lg font-medium transition-colors duration-200"
            onClick={() => window.location.href = "mailto:?subject=Check%20out%20SiteMaster&body=I%20found%20this%20great%20web%20app%20for%20site%20editing:%20" + window.location.href}
          >
            Email Link to My Desktop
          </button>
        </div>
      </div>
    </div>
  );
}